import React from 'react';

const GuestGate = ({ component: Component }) => <Component />;

export default GuestGate;
